import React, { Component } from 'react'
import '../../../CSS/dashboard.css'
import ReusableButton from '../../../SharedComponents/Button/Button'
import $ from "jquery"
import 'jquery-ui-dist/jquery-ui.min.css';
import { NavLink } from 'react-router-dom'
import { DateRange } from 'react-date-range'
import moment from "moment";
import Loading from '../../../Images/loading.gif'
import * as DashboardCleanersAdminHeaderConstant from './DashboardCleanersAdminHeaderConstant'
import { Redirect } from 'react-router-dom'
import DashboardCleanerLogo from '../../../SharedComponents/DashboardCleanerLogo/DashboardCleanerLogo'
import { IoIosContact } from 'react-icons/io'
import { destroySession } from '../../../Utility/Utility'
import { StoresDropDown } from '../../../CleanersDashboardAPI/CleanersDashboardStoresDropDownAPI'
import { Link } from 'react-router-dom'
import { IconContext } from "react-icons";
// import CleanersDashboardHome from '../../CleanersDashboardHome/CleanersDashboardHome'
const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

class DashboardCleanersAdminHeader extends Component {
    constructor(props) {
        super();
        this.state = {
            redirectLogin: false,
            roleName: '',
            Name : '',
            redirectError400: false,
            redirectError401: false,
            redirectError404: false,
            redirectError500: false,
            VendorName : "",
            roleID : ""

        }
        // this._toggleDivLogout = this._toggleDivLogout.bind(this);
        this.handleLogout = this.handleLogout.bind(this);

    }


    // componentDidMount() {
    //   $(window).on('scroll', function () {
    //     var myDiv = $('.CoopHeaderDashboard');
    //     var st = $(this).scrollTop();
    //     myDiv.height( st );
    //     if(st >= 50) {
    //       $(".CoopHeaderDashboard").css("height", "40");
    //     }
    //     else {
    //       $(".CoopHeaderDashboard").css("height", "90");
    //     } 
    //   })
    // }
    componentWillMount() {
        if (sessionStorage.getItem('token')) {
           var Role = sessionStorage.getItem('role')
           this.setState({
               roleID : Role
           })
           var VendorName = sessionStorage.getItem('vendorName')
           if(Role == "1") {
               Role = VendorName +" "+"Admin"
            this.setState({
                roleName :  Role,
                VendorName : VendorName
            })
           }
           if(Role == "3" ) {
            Role = "Super Admin"
               this.setState({
                roleName :  Role,
               })
           }
            var Name = sessionStorage.getItem('name')
            this.setState({
                Name: Name
              
            })
        }
        else {
            this.setState({
                redirectLogin: true
            })
        }
    }
    handleLogout() {
        destroySession();
        this.setState({
            redirectLogin: true
        })
    }
    render() {
        if (this.state.redirectLogin) {
            return (<Redirect to={'/DashboardLogin'} />)
        }
        if (this.state.redirectError400) {
            return (<Redirect to={'/CleanersDashboardError400'} />)
        }
        if (this.state.redirectError401) {
            return (<Redirect to={'/CleanersDashboardError401'} />)
        }
        if (this.state.redirectError404) {
            return (<Redirect to={'/CleanersDashboardError404'} />)
        }
        if (this.state.redirectError500) {
            return (<Redirect to={'/CleanersDashboardError500'} />)
        }
        return (
            <div>
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                <div className="CoopHeaderDashboardAdmin" >
                    <div className="CoopHeaderAdmin">
                        <DashboardCleanerLogo />
                        {/* <CleanersDashboardHome {...this.state}/> */}
                        <p>{DashboardCleanersAdminHeaderConstant.visit}</p>
                        <button className="button-header">{DashboardCleanersAdminHeaderConstant.cleaning}</button>
                        {this.state.roleName == "Super Admin"?
                        <div className="headerMenuAdminTop">
                        <ul className="header-menuAdmin" >
                        <li>  <NavLink to="#" className="ConfigActive" >{DashboardCleanersAdminHeaderConstant.Config}</NavLink> </li>
                        <li>  <NavLink to="/CleanersDashboardHome" className="ClenaersInactive" >{DashboardCleanersAdminHeaderConstant.CleanersDashboard}</NavLink> </li>
                        </ul>
                        </div>
                         : null
                          }
                             {this.state.roleID ==  "1" ?
                        <div className="headerMenuAdminTop">
                        <ul className="header-menuAdmin" >
                        <li>  <NavLink to="#" className="ConfigActive" >{DashboardCleanersAdminHeaderConstant.Config}</NavLink> </li>
                        <li>  <NavLink to="/CleanersDashboardHome" className="ClenaersInactive" >{DashboardCleanersAdminHeaderConstant.CleanersDashboard}</NavLink> </li>
                        </ul>
                        </div>
                         : null
                          }
                        
                    </div>
                    <div className="coop-visitor">
                        <div className="coopIcon">
                            <div className="roleName">{this.state.roleName}</div>
                            <IconContext.Provider
                                value={{ color: 'white', className: "global-class-name.Dashboard" }}
                            >
                                <IoIosContact size={30} />
                            </IconContext.Provider>
                            <ReusableButton buttonText={this.state.Name} className="RoleName"></ReusableButton>
                           <p className="Logout"> <NavLink to="/CleanersDashboardHelpGuide" className="Help">{DashboardCleanersAdminHeaderConstant.Help}</NavLink></p>
                            <p onClick={this.handleLogout} className="Logout">{DashboardCleanersAdminHeaderConstant.Logout}</p>
                            {/* <ReusableButton buttonText="Logout" onClick={this.handleLogout}></ReusableButton> */}
                            {/* <ReusableButton buttonText={DashboardCleanersAdminHeaderConstant.Cancel} onClick={this._toggleDivLogout} className="LogoutCancel"></ReusableButton> */}
                        </div>
                    </div>
                </div>
                <div className="NavLinks">
                    <div className="DashboardMenuAdmin">
                        <div className="menuAdmin" >
                            <div className="headerMenuAdmin">
                                <ul className="header-menuAdmin" >
                                    <li> <NavLink to="/DashboardAdminCleaningCompanies" >{DashboardCleanersAdminHeaderConstant.CleaningCompanies}</NavLink></li>
                                    <li> <NavLink to="/DashboardScheduleUploadDownload">{DashboardCleanersAdminHeaderConstant.CleaningSchedule}</NavLink></li>
                                    <li> <NavLink to="/DashboardAdminModifySchedule">{DashboardCleanersAdminHeaderConstant.ModifySchedule}</NavLink></li>
                                    <li> <NavLink to="/DashboardAdminManageUser" >{DashboardCleanersAdminHeaderConstant.ManageUser}</NavLink></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }



}
export default DashboardCleanersAdminHeader;